var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IS_EQUAL_EXCHANGE"},[_c('Checkbox',{attrs:{"id":"DEFINE_IS_EQUAL_EXCHANGE"},on:{"on-change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }